export default {
  expiresSoon: 'Dostęp do "{appName}"   zostanie dezaktywowany po {expiryDate}.',
  pinApp: 'Przypnij aplikację do paska nawigacji',
  unpinApp: 'Odepnij aplikację od paska nawigacji',
};
